import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const msg91 = defineConnector({
  identifier: "msg91",
  name: "MSG91",
  tagLine: "Communication platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.msg91\\.com/.*",
  auth: (app) => queryAuth([{ name: "authkey", value: app.secret.authkey }]),
  steps: [
    {
      title: "Get your authkey",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [MSG91](https://control.msg91.com/) account and copy your authkey from the dashboard.",
        },
      ],
    },
    {
      title: "Copy and paste the authkey into the field below",
      items: [
        {
          kind: "input",
          label: "Authkey",
          required: true,
          target: { kind: "secrets", field: "authkey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.msg91.com/api/v5/flow/",
  },
});
